import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useIAm } from "../hooks/useIAm";
import { RoutesPage } from "../constants/routes";

export const DashboardPage = () => {
  const navigate = useNavigate();
  const { data } = useIAm();
  const user = data?.getUser;
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get("redirect_to") || "";

  if (redirectTo) {
    window.location.href = redirectTo;
    return null;
  }

  if (user) {
    const roles = user?.roles;

    if (roles.includes("UPS:Admin")) {
      navigate(RoutesPage.UserManagement);
      return null;
    }
  }
  return <div data-testid="dashboard-empty"></div>;
};
